import { Component } from "@angular/core";

@Component({
  selector: "aa-not-found",
  templateUrl: "./not-found.component.html",
  host: { class: "anonymous-page" },
  standalone: false,
})
export class NotFoundComponent {}
